import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const ConfirmationModal = Dynamic(async () => {
    const { ConfirmationModal } = await import('#pplx/frontend/aether/components/ConfirmationModal/internal/ConfirmationModal.js');
    return { default: ConfirmationModal };
});
//# sourceMappingURL=index.js.map